export const helperText = {
  global: {
    sessionTimeout: "You have been logged out due to inactivity",
    MultipleLogin:
      "Multiple logins have been detected for your account. If you did not initiate these logins, please contact the administrator immediately for assistance.",
    notLoggedIn: "Please login.",
    apiErrorMessage: "Something went wrong",
    notSubscribed:
      "Your account is not active. Please contact our support team via the contact us page to gain access.",
    subscriptionEnded:
      "Oops! It seems that your account validity has expired. To regain access, please reach out to our support team via the Contact Us page, and we'll be glad to assist you in getting back on track.",
    oneDayLeft:
      "Your trial ends in 1 day. Please contact our support team via the contact us page to subscribe.",
    ssnetUser:
      "Login failed. Please login via the SSNET portal to access the site.",
  },
};
